<template>
  <button
    class="tooth-popup"
    type="button"
    v-bind:class="{ flip, selected }"
    v-on:click="toggle">
    <svg
      class="tooth-popup__parts"
      width="26"
      height="51"
      viewBox="0 0 26 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M16.8787 25.4539C16.8787 23.6826 17.9472 18.0071 18.0825 15.3451L7.49207 14.3848C7.5742 18.8158 7.85452 29.3862 8.31878 36.2197C8.78305 43.0533 13.7381 46.8389 15.0681 48.1362C15.2857 48.4058 15.8805 48.6821 16.5189 47.6307C19.8989 42.0643 16.0859 34.566 16.7011 28.0829C16.7994 27.0473 16.8787 26.1366 16.8787 25.4539Z" />
      <path d="M7.5935 1.74782L17.1821 1.69975C17.5114 1.69809 17.8405 1.72008 18.1667 1.76554C18.3236 1.7874 18.4799 1.81552 18.6243 1.88076C18.818 1.96834 19.1102 2.13748 19.3833 2.44174C19.9991 3.12764 20.0115 4.13265 19.9781 5.05379C19.9027 7.13305 19.6147 10.4289 18.8374 13.4235C18.6492 14.1486 18.3894 14.786 18.0826 15.3441C16.9741 17.3614 15.2534 18.3444 14.0907 18.7007C13.731 18.8109 13.3529 18.8317 12.9767 18.8317C12.2457 18.8317 11.5088 18.7351 10.8624 18.3938C9.85029 17.8594 8.58328 16.9153 7.95621 15.5463C7.79828 15.2015 7.64273 14.8071 7.49217 14.3838C7.4597 14.2925 7.42797 14.1997 7.39694 14.1057C6.24708 10.6212 5.78728 6.87683 5.99758 3.21359C6.02768 2.68936 6.20214 2.33278 6.40361 2.10155C6.6886 1.77445 7.15967 1.74782 7.5935 1.74782Z" />
    </svg>
    <div class="tooth-popup__number">{{number}}</div>
  </button>
</template>

<script>
import popupTeethMixin from '@/mixins/popupTeethMixin';

export default {
  mixins: [popupTeethMixin],
  name: 'ToothDown2',
};
</script>

<style>
</style>
